import { Component } from '@verndale/core';
import { v4 as uuidv4 } from 'uuid';
import { open, close } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.accordion__items'),
      items: [...this.el.querySelectorAll('.accordion__item')],
      triggers: [...this.el.querySelectorAll('.accordion__item-trigger button')]
    };

    this.initAccordion();
  }

  addListeners() {
    this.dom.container.addEventListener(
      'keydown',
      this.handleKeyDown.bind(this)
    );
    this.dom.triggers.forEach(trigger =>
      trigger.addEventListener('click', this.handleClick.bind(this))
    );
  }

  initAccordion() {
    this.dom.items.forEach((item, index) => {
      const buttonGuid = uuidv4();
      const contentGuid = uuidv4();

      const button = item.querySelector('.accordion__item-trigger button');
      button.setAttribute('aria-expanded', false);
      button.setAttribute('aria-controls', contentGuid);
      button.setAttribute('id', buttonGuid);

      const content = item.querySelector('.accordion__item-content');
      content.setAttribute('aria-labelledby', buttonGuid);
      content.setAttribute('id', contentGuid);
      content.setAttribute('aria-hidden', true);
    });
  }

  handleClick(e) {
    const button = e.currentTarget;

    if (button.getAttribute('aria-expanded') === 'true') {
      this.closeItem(button);
    } else {
      this.openItem(button);
    }
  }

  handleKeyDown(e) {
    const target = e.target;
    const key = e.which.toString();

    const ctrlModifier = e.ctrlKey && key.match(/33|34/);

    if (target.parentNode.classList.contains('accordion__item-trigger')) {
      if (key.match(/38|40/) || ctrlModifier) {
        const index = this.dom.triggers.indexOf(target);
        const direction = key.match(/34|40/) ? 1 : -1;
        const length = this.dom.triggers.length;
        const newIndex = (index + length + direction) % length;

        this.dom.triggers[newIndex].focus();

        e.preventDefault();
      } else if (key.match(/35|36/)) {
        switch (key) {
          case '36':
            this.dom.triggers[0].focus();
            break;
          case '35':
            this.dom.triggers[this.dom.triggers.length - 1].focus();
            break;
        }
        e.preventDefault();
      }
    }
  }

  openItem(trigger) {
    const content = document.getElementById(
      trigger.getAttribute('aria-controls')
    );

    trigger.setAttribute('aria-expanded', true);
    trigger.parentNode.parentNode.classList.add('accordion__item--active');
    open({
      element: content,
      onComplete: () => {
        content.setAttribute('aria-hidden', false);
        content.style.height = 'auto';
      }
    });
  }

  closeItem(trigger) {
    const content = document.getElementById(
      trigger.getAttribute('aria-controls')
    );

    trigger.setAttribute('aria-expanded', false);
    trigger.parentNode.parentNode.classList.remove('accordion__item--active');
    close({
      element: content,
      onComplete: () => {
        content.setAttribute('aria-hidden', true);
      }
    });
  }
}

export default Module;
